import Image from 'next/image';
import React from 'react';
import FadeInAnimation from "../Common/FadeInAnimation";
import { useTranslations } from '../../locales/useTranslations';
import { BiSearchAlt, BiCloudUpload, BiDirections } from "react-icons/bi";

const ItConsultantService = () => {
    const { t } = useTranslations();

    return (
        <section className="ptb-100 it-consultant-service">
            {/* Hintergrund-Dekoration */}
            <div className="it-consultant-service__decoration it-consultant-service__decoration--top-left"></div>
            <div className="it-consultant-service__decoration it-consultant-service__decoration--bottom-right"></div>

            <div className="container">
                <div className="section-title text-center it-consultant-service__header">
                    <h2 className="it-consultant-service__title">
                        {t('itConsulting_features_title')}
                        <span className="it-consultant-service__title-underline"></span>
                    </h2>
                    <p className="it-consultant-service__description">
                        {t('itConsulting_features_description')}
                    </p>
                </div>
            </div>

            <FadeInAnimation direction="up" delay={50}>
                <div className="it-consultant-service__item">
                    <div className="container max-width-1290">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <div className="it-consultant-service__image-wrapper it-consultant-service__image-wrapper--left">
                                    <Image
                                        src="/images/it-consultant/digital.webp"
                                        alt="simplify data - digital transformation"
                                        width={0}
                                        height={0}
                                        sizes="100vw"
                                        style={{ width: '100%', height: 'auto' }}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="it-consultant-service__content">
                                    <div className="it-consultant-service__badge">
                                        <BiSearchAlt />
                                        01
                                    </div>
                                    <h3 className="it-consultant-service__feature-title">
                                        {t('itConsulting_features_items_1_title')}
                                    </h3>
                                    <p className="it-consultant-service__feature-description">
                                        {t('itConsulting_features_items_1_description')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FadeInAnimation>

            <div className="it-consultant-service__item">
                <FadeInAnimation direction="up" delay={100}>
                    <div className="container max-width-1290">
                        <div className="row align-items-center">
                            {/* For mobile device */}
                            <div className="col-lg-6 col-md-6 d-block d-md-none">
                                <div className="it-consultant-service__image-wrapper it-consultant-service__image-wrapper--right mt-0 mb-4">
                                    <Image
                                        src="/images/it-consultant/prozess.webp"
                                        alt="simplify data - prozessdigitalisierung"
                                        width={0}
                                        height={0}
                                        sizes="100vw"
                                        style={{ width: '100%', height: 'auto' }}
                                    />
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6">
                                <div className="it-consultant-service__content">
                                    <div className="it-consultant-service__badge">
                                        <BiCloudUpload />
                                        02
                                    </div>
                                    <h3 className="it-consultant-service__feature-title">
                                        {t('itConsulting_features_items_2_title')}
                                    </h3>
                                    <p className="it-consultant-service__feature-description">
                                        {t('itConsulting_features_items_2_description')}
                                    </p>
                                </div>
                            </div>

                            {/* For other device */}
                            <div className="col-lg-6 col-md-6 d-none d-md-block">
                                <div className="it-consultant-service__image-wrapper it-consultant-service__image-wrapper--right">
                                    <Image
                                        src="/images/it-consultant/prozess.webp"
                                        alt="simplify data - schnittstellen für ihre daten"
                                        width={0}
                                        height={0}
                                        sizes="100vw"
                                        style={{ width: '100%', height: 'auto' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </FadeInAnimation>
            </div>

            <FadeInAnimation direction="up" delay={150}>
                <div className="it-consultant-service__item">
                    <div className="container max-width-1290">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <div className="it-consultant-service__image-wrapper it-consultant-service__image-wrapper--left">
                                    <Image
                                        src="/images/it-consultant/technology.webp"
                                        alt="simplify data - technology"
                                        width={0}
                                        height={0}
                                        sizes="100vw"
                                        style={{ width: '100%', height: 'auto' }}
                                    />
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6">
                                <div className="it-consultant-service__content">
                                    <div className="it-consultant-service__badge">
                                        <BiDirections />
                                        03
                                    </div>
                                    <h3 className="it-consultant-service__feature-title">
                                        {t('itConsulting_features_items_3_title')}
                                    </h3>
                                    <p className="it-consultant-service__feature-description">
                                        {t('itConsulting_features_items_3_description')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FadeInAnimation>
        </section>
    );
}

export default ItConsultantService;
